/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { reorderContents, addContent, selectContent, updateNoLiveContent } from 'state/actions/embedsState/embedManagementState/content_status';
import { displayModal } from '@insticator/insticator-ui';
import { setEmbedProperty } from 'state/actions/embedsState/embedManagementState/selected_embed_status';
// component
import OrganizeContentPage from 'pages/dashboard/embeds/management/organize/organize';



/* ========== ~~~~~~~~~~ EMBED ORGANIZE : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    const activeContents = Object.values(contentStatus.contents).filter(content => content.contentLive === true);
    const inactiveContents = Object.values(contentStatus.contents).filter(content => content.contentLive === false);
    return {
        location: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location,
        contentOrder: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.contentOrder,
        numOfContents: Object.keys(embedsState.embedManagementState.contentStatus.contents).length,
        contents: embedsState.embedManagementState.contentStatus.contents,
        numberOfActiveContents: activeContents.length,
        numberOfInactiveContents: inactiveContents.length
    }
};
// map actions
const mapDispatchToProps = dispatch => ({
    displayModal: (isVisible, contentToDisplay, showCloseButton) => {
        dispatch(displayModal(isVisible, contentToDisplay, showCloseButton))
    },
    reorderContents: (liveContents, inactiveContents) => dispatch(reorderContents(liveContents, inactiveContents)),
    setEmbedProperty: (property, value) => dispatch(setEmbedProperty(property, value)),
    addContent: contentType => dispatch(addContent(contentType)),
    selectContent: contentId => dispatch(selectContent(contentId)),
    updateNoLiveContent: bool => dispatch(updateNoLiveContent(bool))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(OrganizeContentPage);
